export enum SUPPORTED_VALIDATORS {
  required = 1,
  emailFormat,
  telephoneNumber,
  urlFormat,
}
